export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14276.4ae80211.jpg";